import { ApolloClient, NormalizedCacheObject, makeVar } from '@apollo/client'

export const apolloClient = makeVar<ApolloClient<NormalizedCacheObject> | null>(
  null,
)
